(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6c3a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6c3a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dvYFb", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $9d6d3a12581f8329$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $9d6d3a12581f8329$export$5f0017c582d45a2d; });
function $9d6d3a12581f8329$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

function $46a42d21066e31c6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $46a42d21066e31c6$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $46a42d21066e31c6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $46a42d21066e31c6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $dvYFb = parcelRequire("dvYFb");
var $a8d2d094d9f0b05d$var$extendStatics = function extendStatics1(d, b) {
    $a8d2d094d9f0b05d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a8d2d094d9f0b05d$var$extendStatics(d, b);
};
function $a8d2d094d9f0b05d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a8d2d094d9f0b05d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a8d2d094d9f0b05d$export$18ce0697a983be9b = function __assign1() {
    $a8d2d094d9f0b05d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a8d2d094d9f0b05d$export$18ce0697a983be9b.apply(this, arguments);
};
function $a8d2d094d9f0b05d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a8d2d094d9f0b05d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a8d2d094d9f0b05d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a8d2d094d9f0b05d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a8d2d094d9f0b05d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a8d2d094d9f0b05d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $dvYFb._)(x)) === "symbol" ? x : "".concat(x);
}
function $a8d2d094d9f0b05d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $dvYFb._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a8d2d094d9f0b05d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a8d2d094d9f0b05d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a8d2d094d9f0b05d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a8d2d094d9f0b05d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a8d2d094d9f0b05d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a8d2d094d9f0b05d$export$45d3717a4c69092e(o, m, p);
}
function $a8d2d094d9f0b05d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a8d2d094d9f0b05d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a8d2d094d9f0b05d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a8d2d094d9f0b05d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a8d2d094d9f0b05d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a8d2d094d9f0b05d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a8d2d094d9f0b05d$export$10c90e4f7922046c(v) {
    return this instanceof $a8d2d094d9f0b05d$export$10c90e4f7922046c ? (this.v = v, this) : new $a8d2d094d9f0b05d$export$10c90e4f7922046c(v);
}
function $a8d2d094d9f0b05d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a8d2d094d9f0b05d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a8d2d094d9f0b05d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a8d2d094d9f0b05d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a8d2d094d9f0b05d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a8d2d094d9f0b05d$export$19a8beecd37a4c45 === "function" ? $a8d2d094d9f0b05d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a8d2d094d9f0b05d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a8d2d094d9f0b05d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a8d2d094d9f0b05d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a8d2d094d9f0b05d$export$45d3717a4c69092e(result, mod, k);
    }
    $a8d2d094d9f0b05d$var$__setModuleDefault(result, mod);
    return result;
}
function $a8d2d094d9f0b05d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a8d2d094d9f0b05d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a8d2d094d9f0b05d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a8d2d094d9f0b05d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a8d2d094d9f0b05d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a8d2d094d9f0b05d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a8d2d094d9f0b05d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a8d2d094d9f0b05d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a8d2d094d9f0b05d$export$2e2bcd8739ae039 = {
    __extends: $a8d2d094d9f0b05d$export$a8ba968b8961cb8a,
    __assign: $a8d2d094d9f0b05d$export$18ce0697a983be9b,
    __rest: $a8d2d094d9f0b05d$export$3c9a16f847548506,
    __decorate: $a8d2d094d9f0b05d$export$29e00dfd3077644b,
    __param: $a8d2d094d9f0b05d$export$d5ad3fd78186038f,
    __metadata: $a8d2d094d9f0b05d$export$f1db080c865becb9,
    __awaiter: $a8d2d094d9f0b05d$export$1050f835b63b671e,
    __generator: $a8d2d094d9f0b05d$export$67ebef60e6f28a6,
    __createBinding: $a8d2d094d9f0b05d$export$45d3717a4c69092e,
    __exportStar: $a8d2d094d9f0b05d$export$f33643c0debef087,
    __values: $a8d2d094d9f0b05d$export$19a8beecd37a4c45,
    __read: $a8d2d094d9f0b05d$export$8d051b38c9118094,
    __spread: $a8d2d094d9f0b05d$export$afc72e2116322959,
    __spreadArrays: $a8d2d094d9f0b05d$export$6388937ca91ccae8,
    __spreadArray: $a8d2d094d9f0b05d$export$1216008129fb82ed,
    __await: $a8d2d094d9f0b05d$export$10c90e4f7922046c,
    __asyncGenerator: $a8d2d094d9f0b05d$export$e427f37a30a4de9b,
    __asyncDelegator: $a8d2d094d9f0b05d$export$bbd80228419bb833,
    __asyncValues: $a8d2d094d9f0b05d$export$e3b29a3d6162315f,
    __makeTemplateObject: $a8d2d094d9f0b05d$export$4fb47efe1390b86f,
    __importStar: $a8d2d094d9f0b05d$export$c21735bcef00d192,
    __importDefault: $a8d2d094d9f0b05d$export$da59b14a69baef04,
    __classPrivateFieldGet: $a8d2d094d9f0b05d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a8d2d094d9f0b05d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a8d2d094d9f0b05d$export$81fdc39f203e4e04,
    __addDisposableResource: $a8d2d094d9f0b05d$export$88ac25d8e944e405,
    __disposeResources: $a8d2d094d9f0b05d$export$8f076105dc360e92
};


document.addEventListener("DOMContentLoaded", function() {
    // Variables
    var sections = document.getElementsByClassName("content-map");
    // Initializing Items
    for(var i = 0; i < sections.length; i++){
        var initMap = function initMap(mapWrapper, location, infowindowHeader, infowindowContent) {
            return _initMap.apply(this, arguments);
        };
        // Variables
        var section = sections[i];
        var mapWrapper = section.querySelector(".content-map__wrapper");
        // function to pan with offset
        google.maps.Map.prototype.panToWithOffset = function(latlng, offsetX, offsetY) {
            var map = this;
            var ov = new google.maps.OverlayView();
            ov.onAdd = function() {
                var proj = this.getProjection();
                var aPoint = proj.fromLatLngToContainerPixel(latlng);
                aPoint.x = aPoint.x + offsetX;
                aPoint.y = aPoint.y + offsetY;
                map.panTo(proj.fromContainerPixelToLatLng(aPoint));
            };
            ov.draw = function() {};
            ov.setMap(this);
        };
        function _initMap() {
            _initMap = (0, $46a42d21066e31c6$export$7c398597f8905a1)(function(mapWrapper, location, infowindowHeader, infowindowContent) {
                var Map, AdvancedMarkerElement, map, mapMarker, marker, contentString, infowindow;
                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                google.maps.importLibrary("maps")
                            ];
                        case 1:
                            Map = _state.sent().Map;
                            return [
                                4,
                                google.maps.importLibrary("marker")
                            ];
                        case 2:
                            AdvancedMarkerElement = _state.sent().AdvancedMarkerElement;
                            // Setting up the Map
                            // eslint-disable-next-line no-undef
                            map = new google.maps.Map(mapWrapper, {
                                zoom: 6,
                                center: location,
                                panControl: false,
                                zoomControl: false,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                overviewMapControl: false,
                                rotateControl: false,
                                mapId: "685c7c7095cbf3b4",
                                disableDefaultUI: true,
                                clickableIcons: false
                            });
                            if (window.innerWidth < 640) map.panToWithOffset(location, mapWrapper.offsetWidth / 6 * -1, 0);
                            // Map Marker Functions
                            mapMarker = {
                                url: "../../wp-content/themes/rlx/assets/img/map-marker.svg",
                                scaledSize: new google.maps.Size(38, 38),
                                anchor: new google.maps.Point(19, 19)
                            };
                            marker = new google.maps.Marker({
                                position: location,
                                map: map,
                                icon: mapMarker
                            });
                            if ((infowindowHeader != "" || infowindowHeader) != null && infowindowContent != "" && infowindowContent != null) {
                                contentString = '<div class="content-map__iw-content-wrapper"><h1 class="content-map__iw-header">' + infowindowHeader + "</h1>" + '<div class="content-map__iw-content">' + "<p>" + infowindowContent + "</p>" + "</div></div>";
                                infowindow = new google.maps.InfoWindow({
                                    content: contentString,
                                    ariaLabel: infowindowHeader
                                });
                                marker.addListener("click", function() {
                                    infowindow.open({
                                        anchor: marker,
                                        map: map
                                    });
                                });
                                infowindow.open({
                                    anchor: marker,
                                    map: map
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return _initMap.apply(this, arguments);
        }
        if (mapWrapper) {
            var mapJson = section.querySelector(".content-map__mapData");
            var parsedData = JSON.parse(mapJson.innerHTML);
            var propLat = parsedData.lat;
            var propLng = parsedData.lng;
            var propLocation = {
                lat: Number(propLat),
                lng: Number(propLng)
            };
            var infowindowHeader = parsedData.infoWindowHeader;
            var infowindowContent = parsedData.infoWindowContent;
            initMap(mapWrapper, propLocation, infowindowHeader, infowindowContent);
        }
    }
});

})();
//# sourceMappingURL=content-map.js.map
